import type { SVGProps } from 'react'

export function Stars(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M4.90909 2.18182L6.15874 5.84126L9.81818 7.09091L6.15874 8.34056L4.90909 12L3.65944 8.34056L0 7.09091L3.65944 5.84126L4.90909 2.18182Z"
        fill="currentColor"
      />
      <path
        d="M9.81818 0L10.3736 1.62642L12 2.18182L10.3736 2.73722L9.81818 4.36364L9.26278 2.73722L7.63636 2.18182L9.26278 1.62642L9.81818 0Z"
        fill="currentColor"
      />
    </svg>
  )
}
